import { render, staticRenderFns } from "./XBackgroundImage.vue?vue&type=template&id=6c3607ea&scoped=true"
import script from "./XBackgroundImage.vue?vue&type=script&lang=ts"
export * from "./XBackgroundImage.vue?vue&type=script&lang=ts"
import style0 from "./XBackgroundImage.vue?vue&type=style&index=0&id=6c3607ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3607ea",
  null
  
)

export default component.exports